import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const CheckIcon = ({ type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { viewBox: "0 0 16 13", width: sizePx, height: sizePx, style: styles, ...rest },
        React.createElement("path", { d: "M1.1 7.1l1.7 1.7M5.1 11.3l9.5-9.5", stroke: color, strokeWidth: "2", strokeLinecap: "round" })));
};
export default CheckIcon;
//# sourceMappingURL=index.js.map